export default __webpack_public_path__ + "static/media/12.75bada3e.jpg";